export default __webpack_public_path__ + "static/media/012-pteranodon.34d5f864.svg";